export default function SettingHailey({ color }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 1L12.0357 6.16153C12.2236 6.63799 12.3175 6.87622 12.4614 7.0771C12.5889 7.25516 12.7448 7.41106 12.9229 7.53859C13.1238 7.68245 13.362 7.77641 13.8385 7.96432L19 10L13.8385 12.0357C13.362 12.2236 13.1238 12.3175 12.9229 12.4614C12.7448 12.5889 12.5889 12.7448 12.4614 12.9229C12.3175 13.1238 12.2236 13.362 12.0357 13.8385L10 19L7.96432 13.8385C7.77641 13.362 7.68245 13.1238 7.53859 12.9229C7.41106 12.7448 7.25516 12.5889 7.0771 12.4614C6.87622 12.3175 6.63799 12.2236 6.16153 12.0357L1 10L6.16153 7.96432C6.63799 7.77641 6.87622 7.68245 7.0771 7.53859C7.25516 7.41106 7.41106 7.25516 7.53859 7.0771C7.68245 6.87622 7.77641 6.63799 7.96432 6.16153L10 1Z"
        stroke={color || "#8396A8"}
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
